import {
  FETCH_FEATURES,
  SET_APP_VERSION
} from './mutations-types'
import features from '../../../../static/features'

export default {
  fetchFeatures ({ commit }) {
    commit(FETCH_FEATURES, features)
  },
  setAppVersion ({commit, dispatch}, payload) {
    if (payload === 'demo') {
      dispatch('clearState')
      dispatch('fetchDemoData')
      commit(SET_APP_VERSION, payload)
    } else {
      dispatch('clearState')
      dispatch('fetchApiData')
      commit(SET_APP_VERSION, payload)
    }
  }
}
